import { createSlice } from '@reduxjs/toolkit'

const sizeSlice = createSlice({
    name: 'size/state',
    initialState: {
        deleteConfirmation: false,
        selectedSize: [],
        sortedColumn: () => {},
    },
    reducers: {
        toggleDeleteConfirmation: (state, action) => {
            state.deleteConfirmation = action.payload
        },
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setSelectedSize: (state, action) => {
            state.selectedSize = action.payload
        },
    },
})

export const { 
    toggleDeleteConfirmation, 
    setSortedColumn,
    setSelectedSize
} = sizeSlice.actions

export default sizeSlice.reducer
